import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SimpleHeaderComponent } from '@ildes/basic/simple-header/simple-header.component';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertDialogComponent } from '@ildes/basic/alert-dialog/alert-dialog.component';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { PRIVACY_VERSION } from '../policies/policies-version';
import { SessionStore } from '@ildes/stores/session.store';

@Component({
  selector: 'app-privacy-policy-consent-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatCheckboxModule,
    SimpleHeaderComponent,
    MatButtonModule,
    ReactiveFormsModule,
    AlertDialogComponent,
],
  template: `
    <simple-header title="Política de privacidad" ></simple-header>
    <div class="content padding-top-16">
        <div class="padding-top-8">
            Su confianza es lo más importante para nosotros.
        </div>
        <div class="padding-top-8">
            En ILDES garantizamos que sus datos serán tratados de forma segura y responsable.
        </div>
        <div class="padding-top-8">
            Para continuar, necesitamos que lea y acepte nuestra <a (click)="gotoPrivacyPolicy()" >Política de privacidad</a>
        </div>
        <app-alert-dialog
            *ngIf="!this.clickInPolicy"
            class="margin-top-16"
            [rounded]="true"
            [isCloseable]="false"
            text="Tiene que hacer click en el enlace y leer la Política de Privacidad para poder aceptarla"
            status="info"></app-alert-dialog>
    </div>
    <div>
        <form [formGroup]="formCheckPolicy">
            <mat-checkbox  [disableRipple]="!this.clickInPolicy" (click)="!this.clickInPolicy ? $event.preventDefault(): true"  class="labelText" [class.disabled]="!this.clickInPolicy" formControlName="checked">
            He leído, comprendo y acepto la Política de Privacidad
            </mat-checkbox>
            <div class="align-center">
                <div class="padding-bottom-8">
                <button
                    (click)="onSubmit()"
                    [disabled]="!this.clickInPolicy || formCheckPolicy.invalid"
                    mat-raised-button
                    color="primary"
                    class="button-size-200">Enviar</button>
                </div>
            </div>
        </form>
    </div>
    `,
  styleUrls: ['./privacy-policy-consent-dialog.component.css']
})
export class PrivacyPolicyConsentDialogComponent implements OnInit{
    formCheckPolicy;
    clickInPolicy;
    constructor(
        private dialogRef: MatDialogRef<PrivacyPolicyConsentDialogComponent>,
        private apiManager: ApiManagerService,
        private router: Router
    ) {
        this.clickInPolicy = sessionStorage.getItem('clickInPolicy');

    }
    onSubmit() {
        const id = SessionStore.getInstance().get().user.id;
        this.apiManager.acceptPrivacyPolicy(id, {
            version: PRIVACY_VERSION,
            checked: this.formCheckPolicy.controls['checked'].value
        }).subscribe(() => {
            SessionStore.updateUserInfo({
                privacyPolicyCheck: true,
                privacyPolicyVersion: PRIVACY_VERSION
            });

        }, () => {});
        this.dialogRef.close();
    }
    ngOnInit() {
        this.formCheckPolicy = new FormGroup({
            checked: new FormControl(false, Validators.requiredTrue)
        })
    }

    gotoPrivacyPolicy() {
        this.clickInPolicy = true;
        sessionStorage.setItem('clickInPolicy', this.clickInPolicy);
        this.dialogRef.close();
        this.router.navigate(['/policies/privacy']);
    }
}
